import { ConfigurationDto } from "@intelligems/ig-types/dtos/configurations";

export const checkAllScopes = (validations: boolean[]) => {
  return validations.every((validation) => validation);
};

export const checkAnyScope = (validations: boolean[]) => {
  return validations.some((validation) => validation);
};

export const checkNumberScope = (
  scope: string,
  configurations: ConfigurationDto[],
  currentValue: number
): boolean => {
  if (!scope) {
    return false;
  } else {
    const foundScope = configurations.find((config) => config.key === scope);
    if (!foundScope) {
      return false;
    } else {
      return foundScope.value <= currentValue;
    }
  }
};

export const checkBooleanScope = (
  scope: string,
  configurations: ConfigurationDto[]
): boolean => {
  if (!scope) {
    return false;
  } else {
    const foundScope = configurations.find((config) => config.key === scope);
    if (!foundScope) {
      return false;
    } else {
      return foundScope.value;
    }
  }
};
